<template>
    <div class="fileDisplay">
        <span class="fName">{{this.file.name}}</span><span class="deleteBtn" @click='deleteFile'>삭제</span>
    </div>
</template>
<script>
    export default {
        props: ['file'],
        data() {
            return {
                fileName: '',
                listCount: null,
            }
        },
        methods: {
            deleteFile(){
                this.$emit('childs-event', this.listCount);
            }
        },
        mounted() {
            this.fileName = this.file.name;
            this.listCount = this.file.listCount;
        }
    }
</script>
<style>
    .fileDisplay{
        margin-top:5px;
    }

    .fileDisplay .deleteBtn{
        color: #d43f3a;
        margin-left: 10px;
        cursor: pointer;
    }

    .fName{
      cursor: pointer;
    }
</style>